// React
import PropTypes from "prop-types";
import { useContext, useEffect } from "react";

// @mui material components
import {
  Autocomplete,
  Card,
  Fade,
  Grid,
  Icon,
  InputLabel,
  Modal,
  TextField,
  Tooltip,
} from "@mui/material";

import { gql, useLazyQuery } from "@apollo/client";
import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";
import SoftTypography from "components/SoftTypography";
import { MessageManager } from "context";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  maxHeight: "90%",
  width: { xs: "90%", sm: "80%", xxl: "70%" },
  overflowY: "auto",
  p: 3,
};

export default function ModalResiduos({ open, handleClose, setResiduo, residuo }) {
  const { handleSnackbar } = useContext(MessageManager);

  const [getResiduos, { data }] = useLazyQuery(
    gql`
      query getResiduos {
        residuos {
          __typename @skip(if: true)
          id
          item
          descripcion
          idTratamiento
        }
      }
    `,
    {
      fetchPolicy: "no-cache",
    }
  );

  useEffect(() => {
    if (open) {
      getResiduos()
        .then((res) => {
          console.log(res);
        })
        .catch((e) => {
          handleSnackbar(e.message || "Error al obtener los residuos", "error");
        });
    }
  }, [open]);

  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      open={open}
      onClose={handleClose}
      closeAfterTransition
    >
      <Fade in={open}>
        <Card sx={style}>
          <SoftBox>
            <SoftBox display="flex" justifyContent="space-between" alignItems="center">
              <SoftTypography variant="h6">Elegir tipo de residuo</SoftTypography>
              <Tooltip title="Cerrar" placement="top">
                <Icon fontSize="medium" onClick={handleClose} sx={{ cursor: "pointer" }}>
                  close
                </Icon>
              </Tooltip>
            </SoftBox>
            <SoftBox py={3}>
              <Grid item xs={12}>
                <InputLabel htmlFor="actividad">
                  <SoftTypography component="label" variant="caption" fontWeight="bold">
                    Actividad
                  </SoftTypography>
                </InputLabel>
                <Autocomplete
                  id="actividad"
                  size="small"
                  options={data?.residuos || []}
                  getOptionLabel={(option) => `${option.item} - ${option.descripcion}`}
                  onChange={(event, newValue) => {
                    setResiduo((prev) => ({
                      ...prev,
                      idResiduo: newValue?.id || null,
                      tipoResiduo: newValue?.item || null,
                      descripcionResiduo: newValue?.descripcion || null,
                      idsTratamiento: newValue?.idTratamiento || null,
                      idTratamiento: null,
                      tipoTratamiento: null,
                      descripcionTratamiento: null,
                    }));
                  }}
                  renderInput={(params) => <TextField {...params} />}
                />
              </Grid>
            </SoftBox>
            <SoftBox display="flex" justifyContent="flex-end" alignItems="center">
              <SoftButton color="primary" onClick={handleClose} sx={{ marginRight: 1 }}>
                <Icon sx={{ fontWeight: "light" }}>close</Icon>
                &nbsp;Cerrar y guardar
              </SoftButton>
            </SoftBox>
          </SoftBox>
        </Card>
      </Fade>
    </Modal>
  );
}

ModalResiduos.propTypes = {
  open: PropTypes.bool,
  handleClose: PropTypes.func,
  setResiduo: PropTypes.func,
  residuo: PropTypes.object,
};
